import React from "react";
import { useTranslation } from "react-i18next";
import BPENotFoundIcon from "assets/images/icons/not-found.svg";
import clsx from "clsx";

interface NotFoundProps {
  description?: string;
  noZIndex?: boolean;
  containerClassName?: string;
}

export default function NotFound({
  description,
  noZIndex,
  ...props
}: NotFoundProps) {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        "flex h-full text-center items-center justify-center text-sm text-gray-500",
        props.containerClassName
      )}
    >
      <div
        className={`flex flex-col ${
          noZIndex ? "z-2" : "-z-10"
        } w-fit mt-16 items-center justify-center`}
      >
        <span>
          <img alt="not-found" src={BPENotFoundIcon} className="pt-2" />
        </span>
        <span className="font-normal text-sm text-gray-500 p-4 w-96 text-center">
          {description ?? t("mapping.noResults")}
        </span>
      </div>
    </div>
  );
}
